import { Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { get } from 'lodash';
import { ComponentType } from 'react';
import { Link } from 'react-router-dom';
import { stripHtml } from 'src/common/utils/format-utils';
import { PHOTO_PLACEHOLDER } from 'src/constants/base';
import { ROUTES } from 'src/constants/routes';
import { dateFormat } from 'src/hooks/useDate';
import useStyles from './styles';

interface NewsCardProps {
  item: Record<string, any>;
}

export const NewsCard: ComponentType<NewsCardProps> = ({ item }) => {
  const classes = useStyles();

  return (
    <Link to={ROUTES.NEWS.POST.replace(':id', item.id)} className={classes.root}>
      <Box mb={2} className={classes.image}>
        <img src={get(item, 'cover.thumbnails.medium.url', PHOTO_PLACEHOLDER)} alt={item.title} />
      </Box>
      <Stack spacing={1.5}>
        <Typography variant="subtitle3" color="secondary">
          {dateFormat(item.createdAt, 'D F Y')}
        </Typography>
        <Typography variant="h4" className={classes.title}>
          {item.title}
        </Typography>
        <Typography variant="body2" color="grey.600">
          {stripHtml(item.description).substring(0, 150)}...
        </Typography>
      </Stack>
    </Link>
  );
};
